"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _AcquisitionTime = require("@/utils/AcquisitionTime");
var _memberBalanceDetails = require("@/api/financialManagement/memberBalanceDetails");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  props: {
    memberId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      queryData: {
        incomeType: 'self',
        transType: null,
        transTimeStart: null,
        transTimeEnd: null,
        page: 1,
        size: 10,
        needBalanceCount: true
      },
      statusTypeDataIndex: 0,
      statusTypeData: [{
        name: '今日',
        id: 1
      }, {
        name: '昨日',
        id: 2
      }, {
        name: '近7天',
        id: 3
      }, {
        name: '本月',
        id: 4
      }, {
        name: '上月',
        id: 5
      }, {
        name: '自定义',
        id: 6
      }],
      value1: '',
      balanceData: {},
      tableData: [],
      total: 0,
      balance: null
    };
  },
  created: function created() {
    this.value1 = (0, _AcquisitionTime.getTodayTimeRange)();
    this.listBalance();
    this.loadBalance();
  },
  methods: {
    onStatusList: function onStatusList(data, index) {
      this.statusTypeDataIndex = index;
      if (data.id === 1) {
        this.value1 = (0, _AcquisitionTime.getTodayTimeRange)();
      }
      if (data.id === 2) {
        this.value1 = (0, _AcquisitionTime.getYesterday)();
      }
      if (data.id === 3) {
        this.value1 = (0, _AcquisitionTime.getLast7Days)();
      }
      if (data.id === 4) {
        this.value1 = (0, _AcquisitionTime.getLastCurrentMonth)();
      }
      if (data.id === 5) {
        this.value1 = (0, _AcquisitionTime.getLastMonthDates)();
      }
      if (data.id === 6) {
        this.value1 = [];
        return false;
      }
      this.listBalance();
    },
    changeDataPicker: function changeDataPicker() {
      this.listBalance();
    },
    onInquire: function onInquire() {
      this.queryData.transTimeStart = this.value1[0];
      this.queryData.transTimeEnd = this.value1[1];
      this.listBalance();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        incomeType: 'self',
        transType: null,
        transTimeStart: null,
        transTimeEnd: null,
        page: 1,
        size: 10,
        needBalanceCount: true
      };
      // this.statusTypeDataIndex = 0
      // this.value1 = getTodayTimeRange()
      this.listBalance();
    },
    listBalance: function () {
      var _listBalance2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              if (this.value1.length > 0) {
                this.queryData.transTimeStart = this.value1[0];
                this.queryData.transTimeEnd = this.value1[1];
              }
              params = (0, _objectSpread2.default)({
                memberId: this.memberId
              }, this.queryData);
              _context.n = 1;
              return (0, _memberBalanceDetails.listBalance)(params);
            case 1:
              res = _context.v;
              console.log(res, '================------------');
              this.tableData = res.data.dataPage.data;
              this.total = res.data.dataPage.total;
              this.balanceData = res.data.flowStats === null ? {} : res.data.flowStats;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listBalance() {
        return _listBalance2.apply(this, arguments);
      }
      return listBalance;
    }(),
    loadBalance: function () {
      var _loadBalance2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                memberId: this.memberId,
                incomeType: 'self'
              };
              _context2.n = 1;
              return (0, _memberBalanceDetails.loadBalance)(params);
            case 1:
              res = _context2.v;
              console.log('res', res);
              if (res.code === 0) {
                this.balance = res.data.balance;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadBalance() {
        return _loadBalance2.apply(this, arguments);
      }
      return loadBalance;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listBalance();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listBalance();
    }
  }
};